import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import { utcToGmt } from '../../components/utils';
import { DateText, DocumentLabel, DocumentNumber } from '../../components';
import { InvoiceItems } from './InvoiceItems';
import { Receipt } from './Receipt';

export const PdfInvoiceStandard = ({ dataBilling = {} }) => {
  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <Text style={{...styles.h2, borderBottom: '1pt solid #dfe1e6', paddingBottom: '2mm', marginBottom: '4mm'}}>Fatura</Text>

        {/* Section: CLIENTE */}
        <View style={{...styles.meta, marginBottom: '4mm'}}>
          <View style={styles.column}>
            <Text style={styles.label}>Cliente</Text>
            <Text style={{...styles.text, marginBottom: 10}}>{dataBilling?.payerName}</Text>
            <Text style={styles.label}>Data de Vencimento</Text>
            <Text style={{...styles.text, marginBottom: 10}}>
              <DateText date={dataBilling.invoiceDueDate} />
            </Text>
          </View>
          <View style={styles.column}>
            <Text style={styles.label}>
              <DocumentLabel number={dataBilling.payerDocumentNumber} />
            </Text>
            <Text style={{...styles.text, marginBottom: 10}}>
              <DocumentNumber number={dataBilling.payerDocumentNumber} />
            </Text>
            <Text style={styles.label}>Endereço</Text>
            <Text style={{...styles.text, marginBottom: 10}}>{dataBilling?.payerAddress}</Text>
          </View>
        </View>

        {/* Section: DETALHES DA FATURA */}
        <Text style={{...styles.h2, borderBottom: '1pt solid #dfe1e6', paddingBottom: '2mm', marginBottom: '4mm'}}>Detalhes da Fatura</Text>

        <View style={{...styles.meta, marginBottom: '4mm'}}>
          <View style={styles.column}>
            <Text style={styles.label}>Data da Emissão</Text>
            <Text style={{...styles.text, marginBottom: 10}}>
              <DateText date={utcToGmt(dataBilling.invoiceCreatedDate)} />
            </Text>
          </View>
          <View style={styles.column}>
            <Text style={styles.label}>Identificador da Fatura</Text>
            <Text style={{...styles.text, marginBottom: 10}}>{dataBilling.invoiceIdentify}</Text>
          </View>
        </View>

        <InvoiceItems items={dataBilling.invoiceItems} />

        <Receipt dataBilling={dataBilling} />
      </Page>
    </Document>
  );
};